import { AlertDialog as RA } from 'radix-ui';
import type { ReactNode } from 'react';
import { Button } from './Button';

type Props = {
  open: boolean; onOpenChange: (o: boolean) => void; title: string; children: ReactNode;
  confirmLabel: string; cancelLabel?: string; danger?: boolean; onConfirm: () => void | Promise<void>;
};

/** Destructive or irreversible confirmations, in the same shell as a dialog. Only these use the red button (8d). */
export function ConfirmDialog({ open, onOpenChange, title, children, confirmLabel, cancelLabel = 'Cancel', danger, onConfirm }: Props) {
  return (
    <RA.Root open={open} onOpenChange={onOpenChange}>
      <RA.Portal>
        <RA.Overlay className="fixed inset-0 z-40 bg-[rgba(23,23,26,.18)]" />
        <RA.Content className="fixed z-50 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[calc(100vw-32px)] max-w-[440px] rounded-auth border border-border bg-card shadow-[0_20px_60px_rgba(0,0,0,.18)] outline-none">
          <div className="px-[26px] pt-[22px]">
            <RA.Title className="text-[19px] font-extrabold tracking-[-.02em] m-0 mb-2">{title}</RA.Title>
            <RA.Description asChild><div className="text-[13px] font-semibold text-ink-body leading-[1.55]">{children}</div></RA.Description>
          </div>
          <div className="flex justify-end gap-[10px] px-[26px] py-[18px] mt-5 border-t border-header-rule bg-canvas">
            <RA.Cancel asChild><Button variant="secondary" size="dialog">{cancelLabel}</Button></RA.Cancel>
            <RA.Action asChild><Button variant={danger ? 'danger' : 'primary'} size="dialog" onClick={() => void onConfirm()}>{confirmLabel}</Button></RA.Action>
          </div>
        </RA.Content>
      </RA.Portal>
    </RA.Root>
  );
}
